import React from "react";
import Firebase from "firebase";
import openWebPage from "../../../../Common/Helper/openWebPage";
import FeaturedLink from "../../../../Common/Models/FeaturedLink";
import {useCollection} from "react-firebase-hooks/firestore";
import FeaturedLinkListItem from "../../../../Common/Views/ListItems/FeaturedLinkListItem";

const FeaturedLinksPageController = () => {

    const [featuredLinks] = useCollection(Firebase.firestore().collection('Misc').orderBy('Order'));

    const onClick = (link: FeaturedLink) => {
        // @ts-ignore
        switch(link.title) {
            case 'manhattan.edu':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/manhattan.edu', page_title: 'manhattan.edu'});
                break;
            case 'gojaspers.com':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/gojaspers.com', page_title: 'gojaspers.com'});
                break;
            case 'Self-Service':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/self-service', page_title: 'self-service'});
                break;
            case 'Connect to Wireless Display':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/connect-to-wireless-display', page_title: 'connect-to-wireless-display'});
                break;
            case 'Locate an Open Computer':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/locate-an-open-computer', page_title: 'locate-an-open-computer'});
                break;
            case 'Report a Wifi issue in Dorm':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/report-wifi-issue-in-dorm', page_title: 'report-wifi-issue'});
                break;
            case 'Upload ID Card Photo':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/upload-id-card-photo', page_title: 'upload-id-card-photo'});
                break;
            case 'Glance MC 2.0 Feedback':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/glance-mc-2.0-feedback', page_title: 'glance-mc-feedback'});
                break;
            case 'Rate Us on the App Store!':
                Firebase.analytics().logEvent('Featured Link', { page_location:  'Dashboard/rate-us-in-app-store', page_title: 'rate-us'});
                break;
            default:
            // code block
        }
        openWebPage(link.url);
    };

    return (
        <>
            {featuredLinks &&
                featuredLinks.docs.map((doc: any) => {
                    const link = doc.data();
                    return <FeaturedLinkListItem key={doc.id}
                                          item={{Order: link.Order, url: link.URL, title: doc.id}}
                                          onClick={onClick} displayFavorite={false}/>
                })
            }
        </>
    );
};

export default FeaturedLinksPageController;